/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gbp_Select_LocationInputs */

const cs_integrations_gbp_select_location = /** @type {(inputs: Integrations_Gbp_Select_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit pobočku`)
};

const en_integrations_gbp_select_location = /** @type {(inputs: Integrations_Gbp_Select_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save location`)
};

/**
* | output |
* | --- |
* | "Save location" |
*
* @param {Integrations_Gbp_Select_LocationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gbp_select_location = /** @type {((inputs?: Integrations_Gbp_Select_LocationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gbp_Select_LocationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gbp_select_location(inputs)
	return cs_integrations_gbp_select_location(inputs)
});